class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {      
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    const self = this;
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
        
   
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;   
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
         updateData();
         gemSlider();
         updateVariantImages();
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);   
    setTimeout(() => {
       updateData();
       gemSlider();
       updateVariantImages();
     }, 3000);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
    setTimeout(() => {
       updateData();
       gemSlider();
       updateVariantImages();
     }, 3000);
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;   
    setTimeout(() => {      
       updateData();
       gemSlider();
       updateVariantImages();
       searchParam();     
     }, 1000);
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, #FacetFiltersFormMobile1 .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();    
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {         
          forms.push(this.createSearchParams(form));         
        }       
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
  
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
    const dataClear = this.getAttribute('data-clear');    
    setTimeout(() => {
      removeActive(dataClear, this);
    }, 2500);
  }
}

customElements.define('facet-remove', FacetRemove);

function removeActive(clearVal, element) {
  const text = clearVal;  
   $(".advanced-filter").each(function(){        
      var val = $(this).data('value');        
       if(val === text) {              
          $(this).removeClass('active-filter');
       }
    });    
  if (element.classList.contains('active-facets__button-wrapper')) {
    $(".advanced-filter").removeClass('active-filter');
  }
}  
// Function to update label content with the image
  function updateLabelWithImage(selectedValue, labelFor) {
    // console.log(selectedValue);
    var imageSrc;

    // Map the selected value to the corresponding image source
    switch (selectedValue) { 
        case 'Amethyst': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/RoundAmethyst.jpg'
        break;
        case 'Aquamarine': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/RoundAquamarine.jpg'
        break;
        case 'Blue Topaz': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/RoundBlue_Topaz.jpg'
        break;
        case 'Citrine': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/RoundCitrine.jpg'
        break;
        case 'Emerald': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/RoundEmerald.jpg'
        break;
        case 'Garnet': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/RoundGarnet.jpg'
        break;
        case 'Morganite': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/RoundMorganite.jpg'
        break;
        case 'Opal': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/RoundOpal.jpg'
        break;
        case 'Peridot': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/RoundPeridot.jpg'
        break;
        case 'Pink Tourmaline': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/RoundPink_Tourmaline.jpg'
        break;
        case 'Sapphire': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/RoundSapphire.jpg'
        break;
        case 'Ruby': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/RoundRuby.jpg'
        break;
        case 'Tanzanite': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/RoundTanzanite.jpg'
        break;
        case '14K White Gold':
        imageSrc = 'https://inspereza.com/cdn/shop/files/14K_White_Gold_Amethyst.jpg';
        break;
        case '14K Yellow Gold':
        imageSrc = 'https://inspereza.com/cdn/shop/files/14K_Yellow_Gold_Amethyst.jpg';
        break;
        case '14K Rose Gold':
        imageSrc = 'https://inspereza.com/cdn/shop/files/14K_Rose_Gold_Amethyst.jpg';
        break;
        case '18K White Gold':
        imageSrc = 'https://inspereza.com/cdn/shop/files/18K_White_Gold_Amethyst.jpg'
        break;
        case '18K Yellow Gold':
        imageSrc = 'https://inspereza.com/cdn/shop/files/18K_Yellow_Gold_Amethyst.jpg'
        break;
        case '18K Rose Gold':
        imageSrc = 'https://inspereza.com/cdn/shop/files/18K_Rose_Gold_Amethyst.jpg'
        break;
        case 'Platinum':
        imageSrc = 'https://inspereza.com/cdn/shop/files/Platinum_Amethyst.jpg'
        break;
        case '14K RG/WG': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/14K_RG_WG_Peridot.jpg'
        break;
        case '14K WG/RG':
        imageSrc = 'https://inspereza.com/cdn/shop/files/14K_WG_RG.jpg'
        break;
        case '18K WG/RG':
        imageSrc = 'https://inspereza.com/cdn/shop/files/18K_WG_RG.jpg'
        break;
        case '18K YG/WG':
        imageSrc = 'https://inspereza.com/cdn/shop/files/18K_YG_WG.jpg'
        break;
        case '18K RG/WG':
        imageSrc = 'https://inspereza.com/cdn/shop/files/18K_RG_WG.jpg'
        break;
        case '14K YG/WG':
        imageSrc = 'https://inspereza.com/cdn/shop/files/14K_YG_WG.jpg'
        break;
        case 'Silver': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/Silver_Peridot.jpg'
        break;
        case 'Diamond': 
        imageSrc = 'https://inspereza.com/cdn/shop/files/RoundDiamond.jpg'
        break;
        default:
        imageSrc = 'https://cdn.shopify.com/s/files/1/0695/3130/4243/files/Rectangle_6137.png';
    }
    $('.variant-images label[for="' + labelFor + '"]').html('<img src="' + imageSrc + '" alt="' + selectedValue + '">');
  }
function updateData() {
  // On page load, update label content for all radio inputs 
  $('.variant-images input[type="radio"]').each(function() {
    var selectedValue = $(this).val();
    var labelFor = $(this).attr('id');
    updateLabelWithImage(selectedValue, labelFor);
  });
}
updateData();


var radios = document.querySelectorAll(".radio-sort");
const sortDrawer = document.getElementById('sortBy-mobile-custom');
var radioListItems = document.querySelectorAll(".sort-filter-dropdown li");
const overlay = document.getElementById('overlay-mobile');
const sortDropdown = document.querySelector('.sort-by-custom-dropdown');

$('#trigger-custom-sort').on('click', function(e) {
  e.preventDefault();  
  sortDropdown.classList.add('open-drawer');
  $('body').addClass('overflow-hidden-mobile');
  overlay.style.display = 'block';  
});

overlay.addEventListener('click', function(e) {
  e.preventDefault();
  // Check if the click occurred within the dropdown or overlay
  if (e.target === overlay || e.target === sortDrawer) {
    // Close the dropdown
    sortDropdown.classList.remove('open-drawer');
    $('body').removeClass('overflow-hidden-mobile');
    overlay.style.display = 'none';
  }
});

$('.close-sortBy').on('click', function(e) {
  e.preventDefault();  
  sortDropdown.classList.remove('open-drawer');
  $('body').removeClass('overflow-hidden-mobile');
  overlay.style.display = 'none';  
});

radios.forEach(function(radioContainer, index) {
  radioContainer.addEventListener("change", function (e) { 
    e.preventDefault();
    var selectedValue = this.value;
    const parentElement = $("#sortBy-mobile-radios");
    parentElement.find('.list-menu__item.mobile-facets__item').each(function(){
      const value = $(this).find(".facet-radio input[type='radio']").val();       
      const triggerdVal = $(this).find(".facet-radio");
      const btnApply = $("#apply-sorting");
      $(btnApply).on('click', function () {  
        if (selectedValue == value) {        
          triggerdVal.click();   
        }  
        $(".close-sortBy").click();
      })        
    });
  });
});
